






















import { Component } from '@niknevis/vue-modules'
import { Prop, ProvideReactive } from 'vue-property-decorator'
import TableTabs from '@/modules/common/tes-table/components/shared/TableTabs.vue'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import MediaAttachmentDialog from '@/modules/media/components/shared/MediaAttachmentDialog.vue'
import PanelLayout from '@/modules/common/layout/components/panel/PanelLayout.vue'
import PanelContentCampaignShowTabular
  from '@/modules/content-campaign/components/panel/PanelContentCampaignShowTabular.vue'
import SimpleHeader from '@/modules/shared/components/shared/SimpleHeader.vue'
import { ContentCampaignResourceType } from '@/modules/content-campaign/models/content-campaign-resource.model'
import { getContentItemColumnsInPanel } from '@/modules/content-item/models/columns/content-item.column'
import Vue from 'vue'
import PanelContentCampaignItemsTableRow
  from '@/modules/content-campaign/components/panel/table/PanelContentCampaignItemsTableRow.vue'

@Component({
  layout: PanelLayout,
  layoutProps: {
    page_header: 'کمپین تولید محتوا'
  },
  metaInfo: {
    title: 'کمپین تولید محتوا'
  },
  components: {
    SimpleHeader,
    PanelContentCampaignShowTabular,
    TableTabs,
    TesTable,
    MediaAttachmentDialog
  }
})
export default class ShowPage extends Vue {
  @ProvideReactive()
  @Prop() campaign!: ContentCampaignResourceType
  private rowComponent = PanelContentCampaignItemsTableRow
  activeTab = 'total'

  tabs = [
    {
      name: 'total', icon: 'ion list-outline', label: 'همه مقالات', reverse: true,
      count: this.campaign.data.total_items_count
    },
    {
      name: 'pending', icon: 'ion hourglass', label: 'در انتظار بررسی',
      count: this.campaign.data.items_count['pending']
    },
    {
      name: 'queue', icon: 'ion timer', label: 'در صف تولید',
      count: this.campaign.data.items_count['queue']
    },
    {
      name: 'editing', icon: 'ion pencil-outline', label: 'ویراستاری',
      count: this.campaign.data.items_count['editing']
    },
    {
      name: 'completed', icon: 'ion checkmark-circle', label: 'تکمیل شده',
      count: this.campaign.data.items_count['completed']
    },
    {
      name: 'rejected', icon: 'ion close-circle', label: 'رد شده',
      count: this.campaign.data.items_count['rejected']
    },
    {
      name: 'review', icon: 'ion refresh', label: 'بازبینی',
      count: this.campaign.data.items_count['review']
    },
    {
      name: 'cancelled', icon: 'ion close-circle', label: 'لغو شده',
      count: this.campaign.data.items_count['cancelled']
    }
  ]

  get contentItemColumn() {
    return getContentItemColumnsInPanel()
  }

  get filterItems() {
    if (this.activeTab === 'total') return this.campaign.data.items

    return this
      .campaign
      .data
      .items
      .filter(item => item.status === this.activeTab)
  }
}
